import { ThresholdBar } from '../../../../../../components/molecules/threshold-bar/threshold-bar';
import { cn } from '../../../../../../shadcn/lib/utils';
import { useIndicator } from '../../../../context/indicators';
import { AnsweredStatus } from '../../../../utils/surveys/conditions';
import { WithIndicator } from '../../indicators/with-indicator';
import { DetailsScoringProps } from '../types';

import { NotAnswered } from './content-sections';

export const DetailsScoring = ({
  answeredStatus,
  expression,
  value,
  respondentType,
  showIndicators,
}: DetailsScoringProps) => {
  const indicator = useIndicator(respondentType);
  if (answeredStatus !== AnsweredStatus.COMPLETED) {
    return showIndicators ? null : <NotAnswered answeredStatus={answeredStatus} />;
  }

  const thresholds = expression.thresholds.map((threshold) => ({
    label: threshold.text,
    value: Number.parseInt(threshold.value),
  }));

  return (
    <div className={cn(thresholds.length === 0 && 'last:mb-6')}>
      <WithIndicator displayIndicator={showIndicators} indicatorClassName="mt-4" respondentType={respondentType}>
        <ThresholdBar
          appearance={showIndicators ? indicator?.indicatorAppearance : undefined}
          className="max-w-[600px] mt-6"
          disabled={answeredStatus !== AnsweredStatus.COMPLETED}
          maxValue={expression.maxValue ?? 0}
          showAnnotations
          thresholds={thresholds}
          value={value}
        />
      </WithIndicator>
    </div>
  );
};
